import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';


export class SelectDropdownComponent implements OnInit {
   headerText: string = 'This is default header';
   toggleButtonRef: TemplateRef<any>;
   dropdownItem: TemplateRef<any>;
   dropdownFooter: TemplateRef<any>;
   menuItems: any[] = [];
   showSearch: boolean = false;
   disabled: boolean = false;
   loading: boolean = false;

   readonly onSelect: EventEmitter<any> = new EventEmitter();
   readonly onSearch: EventEmitter<any> = new EventEmitter();
   readonly onOpen: EventEmitter<any> = new EventEmitter();
   readonly onClose: EventEmitter<any> = new EventEmitter();

   searchInput: ElementRef;

  constructor() {
  }


  private displayDropdown: boolean = false;

  ngOnInit() {}

  openDropdown() {
    if (!this.disabled) {
      this.loading = false;
      this.displayDropdown = true;
      if (this.searchInput) {
        setTimeout(() => this.searchInput.nativeElement.focus());
      }
      this.onOpen.emit('open');
    }
  }

  closeDropdown() {
    this.displayDropdown = false;
    this.onClose.emit('close');
  }

  selectItem(item: any) {
    this.onSelect.emit(item);
  }

  searchItem(text: string) {
    if (!text.trim()) {
      this.loading = false;
    }
    this.onSearch.emit(text);
  }

  clickOut() {
    if (this.displayDropdown) {
      this.closeDropdown();
    }
  }

  setSearchText(text: string) {
    if (this.searchInput) {
      this.searchInput.nativeElement.value = text;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'f8-select-dropdown',
  templateUrl: './select-dropdown.component.html',
  styleUrls: ['./select-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'headerText': [{ type: Input },],
'toggleButtonRef': [{ type: Input },],
'dropdownItem': [{ type: Input },],
'dropdownFooter': [{ type: Input },],
'menuItems': [{ type: Input },],
'showSearch': [{ type: Input },],
'disabled': [{ type: Input },],
'loading': [{ type: Input },],
'onSelect': [{ type: Output },],
'onSearch': [{ type: Output },],
'onOpen': [{ type: Output },],
'onClose': [{ type: Output },],
'searchInput': [{ type: ViewChild, args: ['searchInput', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
